<template>
  <router-view v-slot="{ Component }">
    <Suspense>
      <div class="h-full min-h-full antialiased">
        <component :is="Component" />
      </div>
    </Suspense>
  </router-view>
</template>

<script lang="ts" setup>
import { tracker } from '@openreplay/tracker';
import trackerAssist from '@openreplay/tracker-assist';
import * as Sentry from '@sentry/vue';
import { onMounted } from 'vue';
import { ExternalScriptName, loadExternalScript } from './external_scripts';

tracker.configure({
  projectKey: import.meta.env.VITE_APP_OPENREPLAY_MERCHANT_PROJECT_ID,
  ingestPoint: 'https://openreplay.elective.com/ingest',

  obscureTextNumbers: true,
  obscureInputNumbers: true,
  obscureInputEmails: true,
});

tracker.use(trackerAssist());

onMounted(async () => {
  if (!['production', 'staging'].includes(import.meta.env.VITE_APP_ENVIRONMENT)) return;

  loadExternalScript(ExternalScriptName.zendesk);
  loadExternalScript(ExternalScriptName.customerio);

  tracker.start().then((result) => {
    if (result.success) {
      Sentry.setContext('openreplay', { sessionId: result.sessionID });
    }
  });
});
</script>

<style lang="scss">
html,
body,
#app {
  height: 100%;
  width: 100%;
}

#app {
  @apply font-light text-primary;
}
</style>
